module.exports = __webpack_public_path__ + "img/ButtonApp.e5988549.png";